export default __webpack_public_path__ + "/dist/images/login-to-alysei.png";